module.exports = __webpack_public_path__ + "img/Ellipse4.f68a530c.png";